import { createQuery } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const GetResourceAgendaPublicTeamScheduleResponseSchema = z.array(
  z.object({
    id: z.number(),
    board: z.number(),
    display_name: z.string().nullish(),
    tasks: z.array(
      z.object({
        start_time: z.string(),
        end_time: z.string(),
        display_name: z.string(),
        color: z.string(),
        style: z.string().nullish(),
        id: z.number()
      })
    ),
    label: z.string().nullish()
  })
);

type GetResourceAgendaPublicTeamScheduleResponse = z.infer<
  typeof GetResourceAgendaPublicTeamScheduleResponseSchema
>;

const GetResourceAgendaPublicTeamScheduleRequestSchema = z.object({
  slug: z.string(),
  start_datetime: z.string(),
  end_datetime: z.string()
});

type GetResourceAgendaPublicTeamScheduleRequest = z.infer<
  typeof GetResourceAgendaPublicTeamScheduleRequestSchema
>;

export const useGetResourceAgendaPublicTeamSchedule = createQuery<
  GetResourceAgendaPublicTeamScheduleResponse,
  GetResourceAgendaPublicTeamScheduleRequest,
  Error
>({
  queryKey: ["resourceAgendaPublicTeamSchedule"],
  staleTime: 1000 * 60,
  // keepPreviousData: true,
  fetcher: async (variables) => {
    return api<
      GetResourceAgendaPublicTeamScheduleRequest,
      GetResourceAgendaPublicTeamScheduleResponse
    >({
      method: "GET",
      // url: `/resource/team-schedule?${boardsString}&start_datetime=:start_datetime&end_datetime=:end_datetime`,
      url: `/public/:slug/team-schedule?start_datetime=:start_datetime&end_datetime=:end_datetime`,
      requestSchema: GetResourceAgendaPublicTeamScheduleRequestSchema,
      responseSchema: GetResourceAgendaPublicTeamScheduleResponseSchema,
      body: variables
    });
  }
});
